import {
  GET_INFO_VECTOR,
  GET_INFO_WMS,
  PASSIVE_INFO_MODE,
} from '../actions/actionTypes';

const initialState = null;

const infoReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_INFO_VECTOR:
      return payload;
    case GET_INFO_WMS:
      return payload;
    case PASSIVE_INFO_MODE:
      return null;
    default:
      return state;
  }
};

export default infoReducer;
